export default __webpack_public_path__ + "static/media/Tutorial6Mobile.5bb83ead.png";